import firebase from 'firebase';

// Production
const firebaseConfig = {
    apiKey: "AIzaSyCFNnJBA4MgCUGxg53IrhXdi8d3cpeoxJ8",
    authDomain: "kaipsoolretail.firebaseapp.com",
    projectId: "kaipsoolretail",
    storageBucket: "kaipsoolretail.appspot.com",
    messagingSenderId: "162654887675",
    appId: "1:162654887675:web:3b7da9215156d6a2b1da5e",
    measurementId: "G-859W3EKXM6"
};

// Satging
// const firebaseConfig = {
//     apiKey: "AIzaSyCzrKFZg9xz5psYYpZBCwn-pnA4GoltZp0",
//     authDomain: "kaipsoolretailstaging.firebaseapp.com",
//     projectId: "kaipsoolretailstaging",
//     storageBucket: "kaipsoolretailstaging.firebasestorage.app",
//     messagingSenderId: "587710853324",
//     appId: "1:587710853324:web:0dc614b7151492c10ad269",
//     measurementId: "G-TDMD9CK2CQ"
// };

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebaseApp.auth();
const storage = firebaseApp.storage();
const googleProvider = new firebase.auth.GoogleAuthProvider();
const functions = firebaseApp.functions();

export { auth, storage, googleProvider, functions };
export default db;